import { ElementTypes } from '../element-types';
import { kebabCase } from 'lodash-es';

export class Plan {
  private static readonly prefix: string = 'plan';
  static readonly PlanSummaryBase: string = `${Plan.prefix}-${ElementTypes.Div}-summary`;
  static readonly PlanSummaryTop: string = `${Plan.PlanSummaryBase}-top`;
  static readonly PlanButton: string = `${Plan.prefix}-${ElementTypes.Button}-select-plan`;
  static readonly PlanPdsLink: string = `${Plan.prefix}-${ElementTypes.Link}-pds`;
  static readonly PlanBenefitBase: string = `${Plan.prefix}-${ElementTypes.Div}-benefit`;
  static readonly MainContent: string = `${Plan.prefix}-${ElementTypes.Div}-main-content`;

  static PlanSummary(planName: string): string {
    return `${Plan.PlanSummaryBase}-${kebabCase(planName)}`;
  }
  static PlanBenefit(index: number): string {
    return `${Plan.PlanBenefitBase}-${index}`;
  }
}
